import CalendarDateApp from './CalendarDateApp';
import CalendarApp from './CalendarApp';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const CalendarAppConfig = {
    auth: [...authRoles.cc, ...authRoles.admin], //  ['cc', 'admin']
    routes  : [
        {
            path     : '/apps/calendar/:date',
            component: CalendarDateApp
        },
        {
            path     : '/apps/calendar',
            component: CalendarApp
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/callHelper/calendar/CalendarAppConfig.js